import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(undefined, "us-central1");

export async function startProCheckout(plan) {
  if (plan !== "monthly" && plan !== "yearly") throw new Error("Choose a valid billing plan.");
  const result = await httpsCallable(functions, "createCheckoutSession")({ plan });
  if (!result.data?.url) throw new Error("Stripe Checkout could not be opened.");
  window.location.assign(result.data.url);
}

export async function openCustomerPortal() {
  const result = await httpsCallable(functions, "createCustomerPortalSession")();
  if (!result.data?.url) throw new Error("Subscription management could not be opened.");
  window.location.assign(result.data.url);
}

export async function migrateProfileEntitlements(previousUsername, newUsername) {
  await httpsCallable(functions, "migrateProfileEntitlements")({ previousUsername, newUsername });
}
